import a, { forwardRef as s } from "react";
import { styled as c } from "@huspy/styled-system/jsx";
import { text as n } from "@huspy/styled-system/recipes";
const p = s((t, e) => {
  const { as: r = "p", ...o } = t, m = c(r, n);
  return /* @__PURE__ */ a.createElement(m, { ref: e, ...o });
});
p.displayName = "Text";
export {
  p as Text
};
